import { Component, Input, EventEmitter, Output, inject } from "@angular/core";

import { SettingsService } from "@core/api/settings.service";

import { CPopupModalService } from "@theme/@confect/services/confect-popup-modal.service";

import { forkJoin } from "rxjs";

export interface User {
  name?: string;
  email: string;
}

@Component({
  selector: "ngx-modal-invite",
  standalone: false,

  templateUrl: "./modal-invite.component.html",
})
export class CModalInviteComponent {
  private ss = inject(SettingsService);
  private popUpService = inject(CPopupModalService);

  invalidInput = false;
  accept;

  users: string[];

  @Input() modalUsers: User[];

  @Output() modalClosed = new EventEmitter();

  @Input() validator = (res) => {
    return res ? true : false;
  };

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  customSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return (
      item.email.toLocaleLowerCase().indexOf(term) > -1 ||
      item.name.toLocaleLowerCase().indexOf(term) > -1
    );
  }

  addTag = (text: string) => {
    if (!this.validator(text)) {
      this.invalidInput = true;
      return;
    }
    return { name: text, email: text };
  };

  closeModal() {
    this.modalClosed.emit(false);
  }

  inviteUsers() {
    const observables = this.users.map((user) => this.ss.inviteUser(user));

    forkJoin(observables).subscribe({
      next: (_) => {
        this.popUpService.success({
          title: "User invited!",
          autoCloseTimeout: 1500,
        });
        this.modalClosed.emit(true);
      },
      error: (_err) => {
        this.popUpService.error({
          title: "Creating user failed",
          autoCloseTimeout: 1500,
        });
      },
    });
  }
}
